import { setDoc, Timestamp, query, collection, where, getDocs, doc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { useState, useMemo } from "react";
import { withReact } from "slate-react";
import { createEditor } from "slate";
import RichTextEditor from "../components/RichTextEditor";
import { IoIosArrowBack } from "react-icons/io";
import Swal from 'sweetalert2';
import { backToTimestamp } from "../components/EditViolation";

const getBlankRichText = () => [{ type: 'paragraph', children: [{ text: '' }] }];

export default function AddViolation({ setAddCheck, userAuth }) {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [addViolation, setAddViolation] = useState({
        arsCode: "",
        fine: 0,
        effectiveStartDate: "",
        add_date: Timestamp.now(),
        reduce: "",
    });

    const handleAdd = async (e) => {
        e.preventDefault();
        if (isSubmitting) {
            return;
        }

        if (addViolation.arsCode.trim() === "" || addViolation.fine === null || addViolation.fine === undefined || addViolation.effectiveStartDate === "") {
            Swal.fire({
                icon: "error",
                title: "Missing Fields!",
                html: "Please fill in all required fields.<br />ARS-Code, Fine, and Start Date are required.",
                confirmButtonColor: "#3085d6",
            });
            return;
        }

        setIsSubmitting(true);

        const q = query(
            collection(db, "violations"),
            where("arsCode", "==", addViolation.arsCode)
        );

        const snapshot = await getDocs(q);

        if (!snapshot.empty) {
            Swal.fire({
                icon: "error",
                title: "Duplicate Violation",
                text: "A violation with this ARS code already exists.",
                confirmButtonColor: "#3085d6",
            });
            setIsSubmitting(false);
            return;
        }

        try {
            const violationRef = collection(db, "violations");
            const newDocRef = doc(violationRef);
            const newDocID = newDocRef.id;

            const hasReduction =
                addViolation.reduce !== "" &&
                addViolation.reduce !== null &&
                addViolation.reduce !== undefined;

            const newViolation = {
                additionalInfo: addValue2,
                acceptableProof: hasReduction ? addValue : getBlankRichText(),
                arsCode: addViolation.arsCode,
                fine: addViolation.fine,
                effectiveStartDate: addViolation.effectiveStartDate,
                add_date: Timestamp.now(),
                add_user: userAuth,
                effectiveEndDate: null,
                modified_date: null,
                modified_user: null,
                originalDocID: newDocID,
                reduce: hasReduction ? Number(addViolation.reduce) : null
            };

            await setDoc(newDocRef, newViolation);

            setAddViolation({
                arsCode: "",
                fine: 0,
                effectiveStartDate: "",
                reduce: "",
            });

            setAddValue(getBlankRichText());
            setAddValue2(getBlankRichText());

            setAddCheck(false);
            setIsSubmitting(false);

            Swal.fire({
                toast: true,
                position: 'bottom',
                icon: 'success',
                title: 'New Violation Added!',
                showConfirmButton: false,
                timer: 3000,
                customClass: {
                    popup: 'swal-bottom-center'
                }
            });

        } catch (error) {

            console.error("Error creating document:", error);

            setIsSubmitting(false);

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to save the new violation.",
                confirmButtonColor: "#3085d6",
            });
        }
    };

    const withInlines = editor => {
        const { isInline } = editor;

        editor.isInline = element => (element.type === 'link' ? true : isInline(element));
        return editor;
    };

    const addEditor = useMemo(() => withInlines(withReact(createEditor())), []);
    const addEditor2 = useMemo(() => withInlines(withReact(createEditor())), []);

    const [addValue, setAddValue] = useState(getBlankRichText);
    const [addValue2, setAddValue2] = useState(getBlankRichText);

    const hasReduction =
        addViolation.reduce !== "" &&
        addViolation.reduce !== null &&
        addViolation.reduce !== undefined;

    return (
        <div className="add-violation-background">
            <div className="add-violation-back-button" onClick={() => setAddCheck(false)}>
                <IoIosArrowBack className="close-add-violation" style={{width: "7vw", height: "40px", color: "#EFBF84", zIndex: 1000}}/>
            </div>

            <h3 style={{ marginTop: "-30px", marginBottom: "10px" }}>Add a Violation</h3>

            <form onSubmit={handleAdd} name="add-violation-form">
                <label htmlFor="arsCode">ARS-Code:</label><input type="text" id="arsCode" style={{ width: "13vw" }} name="arsCode" required
                    placeholder="ARS-Code" value={addViolation.arsCode} onChange={(e) => setAddViolation({ ...addViolation, arsCode: e.target.value }) }
                />

                <label htmlFor="fine-input">Fine:</label>

                <input id="fine-input" type="number" style={{ width: "13vw" }} name="fine" required placeholder="Fine" min="0"
                    value={addViolation.fine} onFocus={(e) => e.target.select()} onChange={(e) => setAddViolation({ ...addViolation, fine: parseFloat(e.target.value) || 0 })}
                    onWheel={(e) => e.target.blur()}
                />

                <label htmlFor="startDate">Start Date:</label>

                <input id="startDate" type="date" style={{ width: "13vw" }} name="startDate" required
                    onChange={(e) => setAddViolation({ ...addViolation, effectiveStartDate: backToTimestamp(e.target.value)})}/>

                <label htmlFor="reduce">Reduce To Amount:</label>

                <input id="reduce" type="number" style={{ width: "13vw" }} name="reduce" placeholder="Reduce Amount (Optional)" min="0"
                    value={addViolation.reduce} onWheel={(e) => e.target.blur()} onChange={(e) => { const value = e.target.value
                        setAddViolation({ ...addViolation, reduce: value });
                        if (value === "") {
                            setAddValue(getBlankRichText());
                        }
                    }}
                />

                <div style={{ width: "50%", marginTop: "15px", marginRight: "auto", marginLeft: "auto", textAlign: "left"}} >
                    <RichTextEditor editor={addEditor} editor2={addEditor2} value={addValue} value2={addValue2} onChange={(newVal) => setAddValue(newVal || getBlankRichText()) }
                        onChange2={(newVal2) => setAddValue2(newVal2 || getBlankRichText())} showFirst={hasReduction}/>
                </div>

                <br />

                <button className="save-add-button" type="submit" disabled={isSubmitting} onClick={handleAdd}>Add Violation</button>
            </form>
        </div>
    );
}